import { combineReducers } from 'redux';

const defaultEditMode = false;
const editMode = (state = defaultEditMode, action) => {
  switch (action.type) {
    case 'SET_EDIT_MODE_PRODUCTS': {
      return action.mode;
    }
    default:
      return state;
  }
};

const activeTab = (state = defaultEditMode, action) => {
  switch (action.type) {
    case 'SET_ACTIVE_TAB': {
      return action.tab;
    }
    default:
      return state;
  }
};

const defaultIsNewProductGroups = false;
const isNewProductGroups = (state = defaultIsNewProductGroups, action) => {
  switch (action.type) {
    case 'SET_CREATE_MODE': {
      return action.mode;
    }
    default:
      return state;
  }
};

const defaultShowDeleteModal = { isOpen: false, index: null };
const showDeleteModal = (state = defaultShowDeleteModal, action) => {
  switch (action.type) {
    case 'SHOW_DELETE_PRODUCT_MODAL': {
      return {
        isOpen: true,
        index: action.productIndex,
      };
    }
    case 'CANCEL_DELETE_PRODUCT':
    case 'CONFIRM_DELETE_PRODUCT': {
      return defaultShowDeleteModal;
    }
    default:
      return state;
  }
};

const defaultProductGroupsData = {
  _id: null,
  groupName: '',
  deleted: false,
  multiSelect: false,
  products: [
    {
      name: '',
      description: '',
      priceList: [
        {
          key: 24,
          desc: '24 Months',
          price: 0,
        },
        {
          key: '36',
          desc: '36 Months',
          price: 0,
        },
        {
          key: '48',
          desc: '48 Months',
          price: 0,
        },
        {
          key: '60',
          desc: '60 Months',
          price: 0,
        },
      ],
    },
  ],
};

const defaultOTCProductGroupsData = {
  _id: null,
  groupName: '',
  deleted: false,
  products: [
    {
      name: '',
      description: '',
      price: 0,
    },
  ],
};

const defaultProduct = {
  name: '',
  description: '',
  priceList: [
    {
      key: 24,
      desc: '24 Months',
      price: 0,
    },
    {
      key: '36',
      desc: '36 Months',
      price: 0,
    },
    {
      key: '48',
      desc: '48 Months',
      price: 0,
    },
    {
      key: '60',
      desc: '60 Months',
      price: 0,
    },
  ],
};

const defaultOTCProduct = {
  name: '',
  description: '',
  price: 0,
};

const productGroupsData = (state = defaultProductGroupsData, action) => {
  switch (action.type) {
    case 'SET_PRODUCT_GROUPS_DATA': {
      return { ...action.productGroupsData };
    }
    case 'RESET_PRODUCT_GROUPS_DATA': {
      if (action.tab === 'services') {
        return { ...defaultProductGroupsData };
      } else {
        return { ...defaultOTCProductGroupsData };
      }
    }
    case 'UPDATE_FIELD_PRODUCT_GROUPS_DATA': {
      const { name, value } = action;
      return {
        ...state,
        [name]: value,
      };
    }
    case 'UPDATE_FIELD_PRODUCT_DATA': {
      const { productIndex, name, value } = action;
      const updateProduct = { ...state.products[productIndex] };
      updateProduct[name] = value;

      return {
        ...state,
        products: [
          ...state.products.slice(0, productIndex),
          updateProduct,
          ...state.products.slice(productIndex + 1),
        ],
      };
    }

    case 'UPDATE_PRICE_PRODUCT': {
      const { productIndex, key, price } = action;
      const updateProduct = JSON.parse(JSON.stringify(state.products[productIndex]));
      const foundPrice = updateProduct.priceList.find(el => el.key === key);
      foundPrice.price = price;

      return {
        ...state,
        products: [
          ...state.products.slice(0, productIndex),
          updateProduct,
          ...state.products.slice(productIndex + 1),
        ],
      };
    }

    case 'UPDATE_OTC_PRICE_PRODUCT': {
      const { productIndex, key, price } = action;
      const updateProduct = JSON.parse(JSON.stringify(state.products[productIndex]));
      updateProduct.price = price;

      return {
        ...state,
        products: [
          ...state.products.slice(0, productIndex),
          updateProduct,
          ...state.products.slice(productIndex + 1),
        ],
      };
    }

    case 'ADD_PRODUCT': {
      return {
        ...state,
        products: [...state.products, defaultProduct],
      };
    }

    case 'ADD_OTC_PRODUCT': {
      return {
        ...state,
        products: [...state.products, defaultOTCProduct],
      };
    }

    case 'DELETE_PRODUCT': {
      return {
        ...state,
        products: [
          ...state.products.slice(0, action.productIndex),
          ...state.products.slice(action.productIndex + 1),
        ],
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  editMode,
  activeTab,
  productGroupsData,
  showDeleteModal,
  isNewProductGroups,
});
